import { Step } from 'react-joyride';

export enum IdeaIndexJoyrideTarget {
  SAVED_SEARCHES = 'joyrideTargetSavedSearches',
  IDEA_CARD = 'joyrideTargetIdeaCard',
  SUBMIT_RESEARCH = 'joyrideTargetSubmitResearch'
}

export const ideaIndexJoyrideSteps: {
  savedSearches: Step;
  ideaCard: Step;
  submitResearch: Step;
} = {
  savedSearches: {
    title: 'Saved Searches',
    target: `[data-joyride-target="${IdeaIndexJoyrideTarget.SAVED_SEARCHES}"]`,
    placement: 'left-start',
    content:
      'Once you’ve added some filters, click “Save Search” to ensure that you’re notified anytime a new report is submitted that matches your criteria.'
  },
  ideaCard: {
    title: 'Idea Card',
    target: `[data-joyride-target="${IdeaIndexJoyrideTarget.IDEA_CARD}"]`,
    placement: 'left-start',
    content: 'Here is a brief summary of an idea. Click the title to read the full report!',
    placementBeacon: 'left-start',
    disableScrolling: true
  },
  submitResearch: {
    title: 'Submit Research',
    target: `[data-joyride-target="${IdeaIndexJoyrideTarget.SUBMIT_RESEARCH}"]`,
    placement: 'left-start',
    content: 'Click here to submit a new research idea to SumZero.'
  }
};
